__turbopack_context__.v({
  "label": "STProgressBar-module__z5PQka__label",
  "progress": "STProgressBar-module__z5PQka__progress",
  "track": "STProgressBar-module__z5PQka__track",
});
